import React, { useState } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { useHistory } from "react-router-dom";

import styles from "./FreePoolAggregate.module.css";

import { AggregateLineDropDownSelector, BackButton, Table } from "../../components";
import AgsnSwapModal from "../../components/AgsnSwapModal/AgsnSwapModal";

import { RESOURCE_TYPE, USER_OPERATIONS } from "../../constants";

import { withAllowedOperationsProvider } from "../../hocs";
import { usePlantAndLinesStore } from "../../providers/PlantAndLinesStore/PlantAndLinesStore";

import { getAggregateAuthOperation } from "../../utils/utils";

const FreePoolAggregate = ({
  aggregate,
  rowsData,
  loadFreePoolAggregates,
  setFreePoolCount,
}) => {
  const history = useHistory();

  const [plant] = usePlantAndLinesStore().plantState;
  const [aggregateLine] = usePlantAndLinesStore().aggregateLineState;

  const ROW_HEIGHT = 38;

  const [selectedAgsnsForSwap, setSelectedAgsnsForSwap] = useState([]);
  const [isAgsnSwapModalOpen, setIsAgsnSwapModalOpen] = useState(false);

  const openAgsnSwapModal = (selectedRows) => {
    setSelectedAgsnsForSwap(selectedRows);
    setIsAgsnSwapModalOpen(true);
  };

  const redirectToApplicationLandingPage = () => {
    history.push("/");
  };

  const setCount = (count) => {
    setFreePoolCount(count);
  };

  const columns = [
    {
      width: 180,
      title: "ASN",
      field: "asn",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 220,
      title: "Part Number",
      field: "partNumber",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 300,
      title: "Part Description",
      field: "partDescription",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 180,
      title: "Status",
      field: "status",
      enableSearch: true,
      enableFilter: true,
    },
  ];

  return (
    <>
      <div className={styles.backButton}>
        <BackButton
          basePath={aggregate}
          action="Free Pool Aggregates"
          handleClick={redirectToApplicationLandingPage}
        />
      </div>
      <div className={styles.RgtTools}>
        <div className={styles.freePoolToolbar}>
          <div className={styles.lineSelect}>
            <span className={styles.selectLineSpan}>Select line</span>

            <AggregateLineDropDownSelector hasActiveEdits={false} />
          </div>
        </div>
      </div>

      <div className={styles.container}>
        <div className={styles.tableView} style={{ height: "100%" }}>
          <Table
            columns={columns}
            defaultColumns={columns}
            rowHeight={ROW_HEIGHT}
            rows={rowsData.data}
            isDataLoading={rowsData.loading}
            setAsnCount={setCount}
            displayHash
            secondaryActions={[
              {
                name: "SWAP",
                actionFn: (selectedRows) => openAgsnSwapModal(selectedRows),
                authOperation: getAggregateAuthOperation(
                  USER_OPERATIONS.AGGREGATE_SWAP,
                  plant,
                ),
                shouldEnable: (selectedRows) => selectedRows.length === 1,
              },
            ]}
          />
        </div>
      </div>

      {isAgsnSwapModalOpen ? (
        <AgsnSwapModal
          open={true}
          setAgsnSwapCount={() => {}}
          setIsAgsnSwapModalOpen={setIsAgsnSwapModalOpen}
          selectedAgsn={selectedAgsnsForSwap}
          loadLinedOutAgsnOfSelectedPlantAndLineForDate={() => {}}
          loadAgsnsForADate={() =>
            loadFreePoolAggregates(plant?.value, aggregateLine?.value)
          }
          selectedDate={moment()}
          backButtonName="Free Pool"
        />
      ) : null}
    </>
  );
};

FreePoolAggregate.propTypes = {
  aggregate: PropTypes.string.isRequired,
  rowsData: PropTypes.shape({
    loading: PropTypes.bool,
    data: PropTypes.array,
    filteredData: PropTypes.array,
  }).isRequired,
  loadFreePoolAggregates: PropTypes.func.isRequired,
  setFreePoolCount: PropTypes.func.isRequired,
};

export default withAllowedOperationsProvider(
  FreePoolAggregate,
  true,
  RESOURCE_TYPE.MATERIAL,
);
